import type { Question } from "~/features/python/ch2/exercise/types/exercise.types";

export const ch2Questions: Question[] = [
  {
    id: "q-1",
    number: 1,
    type: "mcq",
    question: "Python mein variable kis cheez ko store karta hai?",
    options: ["Sirf text", "Koi bhi value", "Sirf numbers", "Sirf True/False"],
    correct: 1,
    explanation: "Variable ek naam hota hai jiske andar different types ki values store ki ja sakti hain.",
    difficulty: "easy",
    topic: "variables",
    concepts: ["variables", "data-types"],
    solutionSteps: [
      "Variable ko aik named storage samjho jahan different values rakhi ja sakti hain.",
      "Yeh sirf text ya sirf number tak limited nahi hota.",
      "Final answer: Koi bhi value.",
    ],
  },
  {
    id: "q-2",
    number: 2,
    type: "mcq",
    question: "Kaunsa variable name valid hai?",
    options: ["1name", "my name", "student_name", "for"],
    correct: 2,
    explanation: "Variable name letter ya underscore se start hota hai aur spaces allowed nahi hotay.",
    difficulty: "easy",
    topic: "variables",
    concepts: ["variables"],
    solutionSteps: [
      "1name invalid hai kyun ke number se start ho raha hai.",
      "my name invalid hai kyun ke space allowed nahi hota.",
      "for invalid hai kyun ke yeh Python keyword hai.",
      "Final answer: student_name.",
    ],
  },
  {
    id: "q-3",
    number: 3,
    type: "mcq",
    question: "5.7 Python mein kis data type ki example hai?",
    options: ["int", "float", "str", "bool"],
    correct: 1,
    explanation: "Decimal wali value float type hoti hai.",
    difficulty: "easy",
    topic: "data-types",
    concepts: ["data-types", "variables"],
    solutionSteps: [
      "Value 5.7 mein decimal point hai.",
      "Decimal wali values Python mein float hoti hain.",
      "Final answer: float.",
    ],
  },
  {
    id: "q-4",
    number: 4,
    type: "mcq",
    question: "\"Ali\" kis type ka example hai?",
    options: ["int", "bool", "str", "float"],
    correct: 2,
    explanation: "Quotes ke andar likha hua text string hota hai.",
    difficulty: "easy",
    topic: "data-types",
    concepts: ["data-types", "variables"],
    solutionSteps: [
      "Ali quotes ke andar likha gaya hai.",
      "Quotes ke andar text ko Python string kehta hai.",
      "Final answer: str.",
    ],
  },
  {
    id: "q-5",
    number: 5,
    type: "mcq",
    question: "Comment wali line ka kya hota hai?",
    options: ["Run hoti hai", "Ignore hoti hai", "Compile error deti hai", "Value store karti hai"],
    correct: 1,
    explanation: "Python comments ko ignore karta hai, is liye woh execute nahi hoti.",
    difficulty: "easy",
    topic: "comments",
    concepts: ["comments"],
    solutionSteps: [
      "Comment line sirf explanation ke liye hoti hai.",
      "Python execution ke waqt is line ko ignore karta hai.",
      "Final answer: Ignore hoti hai.",
    ],
  },
  {
    id: "q-6",
    number: 6,
    type: "mcq",
    question: "5 + 2 * 3 ka result kya hoga?",
    options: ["21", "11", "7", "15"],
    correct: 1,
    explanation: "Multiplication pehle hoti hai, phir addition. Is liye 5 + 6 = 11.",
    difficulty: "medium",
    topic: "operators",
    concepts: ["operators", "expressions"],
    solutionSteps: [
      "Operator precedence ke mutabiq multiplication pehle hoti hai.",
      "2 * 3 = 6.",
      "Phir 5 + 6 = 11.",
      "Final answer: 11.",
    ],
  },
  {
    id: "q-7",
    number: 7,
    type: "mcq",
    question: "Kaunsa comparison operator equality check karta hai?",
    options: ["=", "==", "!=", ">="],
    correct: 1,
    explanation: "== do values ko compare karke batata hai ke woh equal hain ya nahi.",
    difficulty: "medium",
    topic: "operators",
    concepts: ["operators"],
    solutionSteps: [
      "= assignment ke liye hota hai, comparison ke liye nahi.",
      "== specifically equality check karta hai.",
      "Final answer: ==.",
    ],
  },
  {
    id: "q-8",
    number: 8,
    type: "code",
    question: "Is code ka output predict karo:",
    code: "name = 'Ali'\nprint(name)",
    output: "Ali",
    correct: "Ali",
    explanation: "Variable name ke andar 'Ali' store hai, print(name) wahi value dikhaye ga.",
    difficulty: "easy",
    topic: "variables",
    concepts: ["variables", "input-output"],
    solutionSteps: [
      "name variable ke andar 'Ali' store kiya gaya hai.",
      "print(name) variable ki stored value show karta hai.",
      "Final output: Ali.",
    ],
  },
  {
    id: "q-9",
    number: 9,
    type: "code",
    question: "Is code ka output kya hai?",
    code: "age = 18\nprint(age > 16)",
    output: "True",
    correct: "True",
    explanation: "18, 16 se bara hai is liye comparison ka result True ho ga.",
    difficulty: "medium",
    topic: "operators",
    concepts: ["operators", "variables"],
    solutionSteps: [
      "age variable ki value 18 hai.",
      "Expression 18 > 16 evaluate hoti hai.",
      "Yeh condition true hai, is liye output True aata hai.",
    ],
  },
  {
    id: "q-10",
    number: 10,
    type: "code",
    question: "Neechay diye gaye code ka output likho:",
    code: "price = 1200\n# discount baad mein\nprint(price)",
    output: "1200",
    correct: "1200",
    explanation: "Comment ignore hota hai. Sirf print(price) run hota hai aur 1200 show karta hai.",
    difficulty: "medium",
    topic: "comments",
    concepts: ["comments", "variables"],
    solutionSteps: [
      "Comment line execute nahi hoti.",
      "price variable ke andar 1200 stored hai.",
      "print(price) ka output 1200 hai.",
    ],
  },
  {
    id: "q-11",
    number: 11,
    type: "code",
    question: "Is conversion code ka output kya banay ga?",
    code: "value = float('5')\nprint(value)",
    output: "5.0",
    correct: "5.0",
    explanation: "String '5' float mein convert ho kar 5.0 ban jata hai.",
    difficulty: "medium",
    topic: "data-types",
    concepts: ["data-types", "variables"],
    solutionSteps: [
      "String '5' ko float() ke through numeric decimal value mein convert kiya gaya.",
      "Converted value 5.0 bani.",
      "print(value) ka output 5.0 hai.",
    ],
  },
  {
    id: "q-12",
    number: 12,
    type: "code",
    question: "Output predict karo:",
    code: "a = 10\nb = 3\nprint(a // b)",
    output: "3",
    correct: "3",
    explanation: "Floor division decimal ko drop karke integer quotient deti hai.",
    difficulty: "hard",
    topic: "operators",
    concepts: ["operators", "expressions"],
    solutionSteps: [
      "a // b floor division hai.",
      "10 / 3 ka quotient 3.33 hota hai.",
      "Floor division decimal part drop kar deti hai, is liye output 3 hai.",
    ],
  },
  {
    id: "q-13",
    number: 13,
    type: "short",
    question: "Explain the purpose of using comments in Python code.",
    correct: "Comments are used to explain code and improve readability.",
    answer: "Comments code ko explain karti hain, readability improve karti hain, aur debugging mein help karti hain. Execution ke dauran yeh ignore hoti hain.",
    explanation: "Comment program ko change nahi karti, sirf insan ko code samajhne mein help deti hai.",
    difficulty: "easy",
    topic: "comments",
    concepts: ["comments"],
    solutionSteps: [
      "Comments ka primary purpose code ko explain karna hota hai.",
      "Yeh readability aur teamwork dono improve karti hain.",
      "Python execution ke waqt comments ko ignore karta hai.",
    ],
    finalAnswer: "Comments are used to explain code, improve readability, and help debugging without affecting execution.",
  },
  {
    id: "q-14",
    number: 14,
    type: "short",
    question: "What is the difference between int and float in Python?",
    correct: "int has no decimal, float has decimal.",
    answer: "int woh number hota hai jisme decimal nahi hota, jab ke float decimal wala number hota hai.",
    explanation: "Data types value ki nature batati hain. Integer aur float ka farq decimal point se clear hota hai.",
    difficulty: "easy",
    topic: "data-types",
    concepts: ["data-types", "variables"],
    solutionSteps: [
      "int poora number hota hai jaise 5 ya 20.",
      "float decimal number hota hai jaise 5.2 ya 1.75.",
      "Main difference decimal point ka hai.",
    ],
    finalAnswer: "int stores whole numbers, while float stores decimal numbers.",
  },
  {
    id: "q-15",
    number: 15,
    type: "long",
    question: "Evaluate the expression: 10 + 3 * 2 and explain the order of evaluation.",
    correct: "16",
    finalAnswer: "16",
    explanation: "Expression solve karte waqt operator precedence follow hoti hai. Multiplication addition se pehle hoti hai.",
    difficulty: "medium",
    topic: "operators",
    concepts: ["operators", "expressions"],
    solutionSteps: [
      "Expression mein pehle multiplication dekho: 3 * 2.",
      "3 * 2 = 6.",
      "Ab 10 + 6 karo.",
      "Final result 16 aata hai.",
    ],
  },
  {
    id: "q-16",
    number: 16,
    type: "long",
    question: "Write a short note on variables and how they are used in Python programs.",
    correct: "Variables store values with names.",
    finalAnswer: "Variables are named storage locations used to keep data such as numbers or text so the program can reuse them later.",
    explanation: "Long answer mein definition, purpose, aur simple example teenon cover hone chahiye.",
    difficulty: "medium",
    topic: "variables",
    concepts: ["variables", "input-output"],
    solutionSteps: [
      "Variable aik naam hota hai jo value ko temporarily store karta hai.",
      "Python mein variable ke through number, text, ya boolean value store ki ja sakti hai.",
      "Program later isi naam ko use karke value read ya print karta hai.",
      "Example: marks = 87, phir print(marks).",
    ],
  },
  {
    id: "tb-q1",
    number: 17,
    type: "mcq",
    question: "A valid variable name in Python:",
    options: ["variable1", "variable name", "variable#", "1variable"],
    correct: 0,
    explanation: "Variable names spaces ya special characters allow nahi karte. Number se start bhi nahi ho sakta.",
    difficulty: "easy",
    topic: "variables",
    concepts: ["variables"],
    solutionSteps: [
      "variable name mein space allowed nahi hota.",
      "variable# mein special character use hua hai jo invalid hai.",
      "1variable number se start ho raha hai is liye invalid hai.",
      "Final answer: variable1.",
    ],
    finalAnswer: "variable1",
  },
  {
    id: "tb-q2",
    number: 18,
    type: "mcq",
    question: "Output of the following code:\nage = 25\nprint('Age:', age)",
    options: ["Age: 25", "25", "Age", "age"],
    correct: 0,
    explanation: "print('Age:', age) label + variable value dono print karta hai.",
    difficulty: "easy",
    topic: "input-output",
    concepts: ["variables", "input-output"],
    code: "age = 25\nprint('Age:', age)",
    output: "Age: 25",
    solutionSteps: [
      "age variable ke andar 25 store kiya gaya.",
      "print statement label 'Age:' aur variable dono show karta hai.",
      "Final output: Age: 25.",
    ],
    finalAnswer: "Age: 25",
  },
  {
    id: "tb-q3",
    number: 19,
    type: "mcq",
    question: "A loop used to iterate over a collection such as list is:",
    options: ["while loop", "for loop", "do-while loop", "repeat loop"],
    correct: 1,
    explanation: "Python mein collections iterate karne ke liye for loop use hota hai.",
    difficulty: "easy",
    topic: "loops",
    concepts: ["loops"],
    solutionSteps: [
      "Collection ke har item par chalne ke liye Python for loop use karta hai.",
      "while loop manual condition ke sath zyada use hota hai.",
      "Final answer: for loop.",
    ],
    finalAnswer: "for loop",
  },
  {
    id: "tb-q4",
    number: 20,
    type: "mcq",
    question: "A keyword used to define a function in Python:",
    options: ["define", "function", "def", "func"],
    correct: 2,
    explanation: "Python mein function define karne ke liye 'def' keyword use hota hai.",
    difficulty: "easy",
    topic: "functions",
    concepts: ["functions"],
    solutionSteps: [
      "Python ka function declaration keyword fixed hota hai.",
      "Woh keyword def hai, define ya func nahi.",
      "Final answer: def.",
    ],
    finalAnswer: "def",
  },
  {
    id: "tb-s1",
    number: 21,
    type: "short",
    question: "Explain the purpose of using comments in Python code.",
    correct: "Comments explain code and are ignored in execution.",
    answer: "Comments code ko samajhne ke liye likhe jate hain aur execution mein ignore hote hain.",
    explanation: "Comments developers ko code samajhne aur debugging mein help karte hain.",
    difficulty: "easy",
    topic: "comments",
    concepts: ["comments"],
    solutionSteps: [
      "Comments human reader ke liye hoti hain, Python ke liye nahi.",
      "Yeh readability aur debugging dono improve karti hain.",
      "Execution ke waqt comments ignore hoti hain.",
    ],
    finalAnswer: "Comments explain code, improve readability, and are ignored during execution.",
  },
  {
    id: "tb-s2",
    number: 22,
    type: "short",
    question: "Describe the difference between integer and float data types in Python.",
    correct: "Integer whole numbers; float decimal numbers.",
    answer: "Integer whole numbers hotay hain (5), float decimal numbers (5.2).",
    explanation: "Float fractional values store karta hai jab ke int sirf whole numbers.",
    difficulty: "easy",
    topic: "data-types",
    concepts: ["data-types"],
    solutionSteps: [
      "Integer mein decimal point nahi hota.",
      "Float decimal ya fractional value ko store karta hai.",
      "Example: 5 int hai, 5.2 float hai.",
    ],
    finalAnswer: "Integer stores whole numbers, while float stores decimal numbers.",
  },
  {
    id: "tb-l1",
    number: 23,
    type: "long",
    question: "Evaluate the following expressions:\n(a) 18 / 3 + 4 * 2\n(b) (25 + 5 * 2) - 8 / 2\n(c) 12 + (6 * 5) ** 2 / (40 + 2 - 7) + 10\n(d) 45 / (2 * 2 + 3) + 4 * 6 - 7",
    correct: "Use operator precedence",
    explanation: "Operator precedence follow karna zaroori hai warna result galat hoga.",
    difficulty: "hard",
    topic: "operators",
    concepts: ["operators", "expressions"],
    solutionSteps: [
      "BODMAS ya operator precedence follow karo.",
      "Brackets pehle solve karo.",
      "Phir powers, phir multiplication/division, phir addition/subtraction.",
      "Har expression ko isi order mein simplify karo.",
    ],
    finalAnswer: "Expressions ko precedence order se solve kiya jata hai: brackets, powers, multiplication/division, then addition/subtraction.",
  },
  {
    id: "tb-l2",
    number: 24,
    type: "long",
    question: "Write a Python program to check whether a number is positive, negative or zero.",
    correct: "Use if, elif, else",
    explanation: "Conditional statements use hotay hain decision making ke liye.",
    difficulty: "medium",
    topic: "operators",
    concepts: ["operators", "input-output"],
    code: "num = int(input('Enter number: '))\nif num > 0:\n    print('Positive')\nelif num < 0:\n    print('Negative')\nelse:\n    print('Zero')",
    output: "Depends on entered number",
    solutionSteps: [
      "User se number input lo.",
      "Agar number > 0 ho to Positive print karo.",
      "Agar number < 0 ho to Negative print karo.",
      "Warna Zero print karo.",
    ],
    finalAnswer: "Use if / elif / else with comparisons > 0, < 0, and else for zero.",
  },
  {
    id: "tb-l3",
    number: 25,
    type: "long",
    question: "Write a Python program using while loop that prints all odd numbers between 1 and 100.",
    correct: "Use while loop with modulo",
    explanation: "Modulo operator se odd/even check hota hai.",
    difficulty: "medium",
    topic: "loops",
    concepts: ["loops", "operators"],
    code: "i = 1\nwhile i <= 100:\n    if i % 2 != 0:\n        print(i)\n    i += 1",
    output: "1, 3, 5 ... 99",
    solutionSteps: [
      "Variable i ko 1 se start karo.",
      "while loop ko 100 tak chalao.",
      "Modulo se odd numbers check karo.",
      "Har odd value print karo aur i ko increment karo.",
    ],
    finalAnswer: "Use while loop with i % 2 != 0 to print odd numbers from 1 to 99.",
  },
];

export const ch2QuestionLinks = {
  variables: "/11th/computer/python/variables/",
  "data-types": "/11th/computer/python/data-types/",
  comments: "/11th/computer/python/comments/",
  "input-output": "/11th/computer/python/programs/",
  operators: "/11th/computer/python/operators/",
  expressions: "/11th/computer/python/operators/",
  loops: "/11th/computer/python/loops/",
  functions: "/11th/computer/python/functions/",
  modules: "/11th/computer/python/functions/",
} as const;

export const textbookQuestionIds = ["tb-q1", "tb-q2", "tb-q3", "tb-q4", "tb-s1", "tb-s2", "tb-l1", "tb-l2", "tb-l3"] as const;

export function getQuestionById(questionId: string) {
  return ch2Questions.find((question) => question.id === questionId) ?? null;
}

export function getQuestionIndex(questionId: string) {
  return ch2Questions.findIndex((question) => question.id === questionId);
}

export function getNextQuestion(questionId: string) {
  const currentIndex = getQuestionIndex(questionId);

  if (currentIndex === -1 || currentIndex >= ch2Questions.length - 1) {
    return null;
  }

  return ch2Questions[currentIndex + 1];
}
